export const ENDPOINT = '/services/plugin-pdf-plot-area/plugin-pdf-plot-area'

export const requestOptions = {
    credentials: "same-origin",
    cache: "no-cache",
    headers: {
        "Content-Type": "application/json",
        "X-Forwarded-Proto": "https",
        
    },
} as RequestInit;

